@if (selectedTimeBlockComponent() !== null) {
  <div class="dialog-content !k-p-0">
    <app-absence-type-dialog
      [workTimeStart]="workTimeStart()"
      [workTimeEnd]="workTimeEnd()"
      [(fixIntervalDropdownVisible)]="fixIntervalDropdownVisible"
      [selectedTimeBlock]="modifyPlannerEvent(selectedTimeBlockComponent())"
      [footer]="footer"
      [(absenceTypeForm)]="dialogForm"
      [timeOfDaySelectable]="false"
    />
  </div>
}

<ng-template #footer>
  <footer class="k-d-flex k-justify-content-between">
    <div>
      <button
        (click)="cancel()"
        kendoButton
        size="large"
        themeColor="secondary"
        class="k-mr-4 !k-pr-4"
      >
        <span class="custom-symbol close k-mr-3"></span>
        Schließen
      </button>
      @if (
        selectedTimeBlockComponent().id >= 0 &&
        !selectedTimeBlockComponent().timeBlockModel.isActive
      ) {
        <button
          (click)="sendAction(UserOperation.Delete)"
          kendoButton
          themeColor="error"
          class="!k-pr-4"
          size="large"
        >
          <span class="custom-symbol delete k-mr-3 red"></span>
          Löschen
        </button>
      }
    </div>
    <div>
      <button
        kendoButton
        (click)="
          sendAction(
            selectedTimeBlockComponent().id >= 0 ? UserOperation.Update : UserOperation.Create
          )
        "
        themeColor="base"
        class="!k-pr-4"
        size="large"
      >
        <span class="custom-symbol save k-mr-3"></span>
        {{ selectedTimeBlockComponent().id >= 0 ? "Aktualisieren" : "Speichern" }}
      </button>
    </div>
  </footer>
</ng-template>
